import { createContext } from 'react';
import { ISubCategoryPositionItem } from 'types';

export type TChangeSubCategoryPositionSelectedItem = Nullable<string>;
export type TChangeSubCategoryPositionSelectedRestaurant = { id: string; name: string };
export type TTypeOfChangeSubCategoryPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeSubCategoryPositionState {
	IDSelectedCustomer: TChangeSubCategoryPositionSelectedItem;
	selectedRestaurant: TChangeSubCategoryPositionSelectedRestaurant | null;
	IDSelectedCategory: TChangeSubCategoryPositionSelectedItem;
	positionsData: ISubCategoryPositionItem[];
	typeOfModalWindow: TTypeOfChangeSubCategoryPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: TChangeSubCategoryPositionSelectedRestaurant[];
	selectSearchString: string;
}

export const changeSubCategoryPositionInitialState: IChangeSubCategoryPositionState = {
	IDSelectedCustomer: null,
	selectedRestaurant: null,
	IDSelectedCategory: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	selectSearchString: '',
};

export interface IChangeSubCategoryPositionContext extends IChangeSubCategoryPositionState {
	setIDCustomer(value: TChangeSubCategoryPositionSelectedItem): void;
	setRestaurant(value: TChangeSubCategoryPositionSelectedRestaurant | null): void;
	setIDCategory(value: TChangeSubCategoryPositionSelectedItem): void;
	resetSelectedControls(): void;
	setPositionsData(data: ISubCategoryPositionItem[]): void;
	reorderItems(value: ISubCategoryPositionItem[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeSubCategoryPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: TChangeSubCategoryPositionSelectedRestaurant[]): void;
	changeSelectSearchString(value: string): void;
}

export const ChangeSubCategoryPositionContext = createContext<IChangeSubCategoryPositionContext>({
	setIDCustomer: () => undefined,
	setRestaurant: () => undefined,
	setIDCategory: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeSelectSearchString: () => undefined,
	...changeSubCategoryPositionInitialState,
});
